import { getProductIconUrl } from '../../config/productConfig';
import pattern from '../style/images/pattern.svg';

export const ProductIcon = ({ productId, className }: { productId: string; className: string }) => {
    const url = getProductIconUrl(productId) || pattern;
    return <img className={`ProductIcon ${className}`} src={url} alt={productId} />;
};
